import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import FilterRow from '../components/filter_row';
import ReorderableSingleList from 'components/reorderable_single_list/reorderable_single_list';
import { updateFilterOrder, updateFilter, savePluginSetFilters, addFilter } from '../actions/index';
import { filter, isEqual } from 'lodash';

export class PluginSetFilters extends React.Component {
  static propTypes = {
    addFilter: PropTypes.func.isRequired,
    filterFieldOptions: PropTypes.object.isRequired,
    pluginSet: PropTypes.shape({
      id: PropTypes.number,
      pluginFilters: PropTypes.array
    }).isRequired,
    propertyTypes: PropTypes.object.isRequired,
    savePluginSetFilters: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    updateFilterOrder: PropTypes.func.isRequired
  };

  state = {
    persistedPluginSet: this.props.pluginSet,
    saving: false,
    saved: false
  };

  saveFilters = () => {
    this.setState({ saving: true });
    this.props.savePluginSetFilters(this.props.pluginSet.id, this.props.pluginSet.pluginFilters, () => {
      this.setState({ saved: true, saving: false, persistedPluginSet: this.props.pluginSet });
      setTimeout(() => this.setState({ saved: false }), 3000);
    });
  }

  activeFilters = () => {
    return filter(this.props.pluginSet.pluginFilters, f => !f._destroy);
  }

  renderFilters() {
    return this.activeFilters().map((item) => {
      if (item._destroy) {
        return null;
      } else {
        return (
          <FilterRow
            filterFieldOptions={this.props.filterFieldOptions}
            filterModel={item}
            key={item.id}
            propertyTypes={this.props.propertyTypes}
            onUpdate={this.props.updateFilter}
          />
        );
      }

    });
  }

  isDirty() {
    return !isEqual(this.props.pluginSet, this.state.persistedPluginSet);
  }

  renderSaveButton() {
    if (this.state.saved) {
      return <span className='text-success pull-right' name='saved-message'>Changes Saved</span>;
    } else if (this.isDirty()) {
      const buttonText = this.state.saving ? 'Saving ...' : 'Save Changes';
      return (
        <button
          className='btn btn-save btn-sm pull-right'
          disabled={this.state.saving}
          name='save'
          onClick={this.saveFilters}
        >
          {buttonText}
        </button>
      );
    } else {
      return null;
    }
  }

  renderBody() {
    if (this.activeFilters().length == 0) {
      return (
        <Panel className='dashed-border'>
          <Panel.Body>
            <h4 className='text-muted text-center'>
            Using the default filters. Add a new filter to override the defaults.
            </h4>
          </Panel.Body>
        </Panel>
      );
    } else {
      return (
        <Panel>
          <ReorderableSingleList
            listClassName='list-group'
            itemClassName='list-group-item'
            onReorder={this.props.updateFilterOrder}
          >
            {this.renderFilters()}
          </ReorderableSingleList>
        </Panel>
      );
    }
  }

  render() {
    return (
      <div>
        { this.renderBody() }
        <span
          className='btn btn-create btn-sm'
          onClick={this.props.addFilter}
        >
          + Add New Field
        </span>
        { this.renderSaveButton() }
      </div>
    );
  }
}

function mapStateToProps({ pluginSet }) {
  return { pluginSet };
}
const actions = { updateFilterOrder, updateFilter, savePluginSetFilters, addFilter };

export default connect(mapStateToProps, actions)(PluginSetFilters);
